<div class="stepper-wrapper">
  <p-stepper [value]="stepPanel.PanelOne" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Pedidos</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Detalle del Pedido</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="stepPanel.PanelOne">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [data]="data"
              [isMultipleSelect]="false" [headers]="header" [previousFilters]="filters"
              (onRecoverData)="getMassiveOrderForSelection()" (selectionChange)="selectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="d-flex justify-content-end mt-2">
            <app-custom-button [width]="'7'" [severity]="'contrast'" [label]="'Siguiente'" [icon]="'pi pi-arrow-right'"
              (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="container-style">
            <app-custom-table #tableDetail [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
              [selectAllByDefault]="true" [data]="dataDetail" [headers]="headerDetail"
              (onRecoverData)="getMassiveOrderDetailForSelection()" (onPageChange)="onPageChange($event)"
              (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
          </div>
          <div class="d-flex mt-2 justify-content-start">
            <app-custom-button [width]="'7'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
              (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>